module.exports = __webpack_public_path__ + "img/ls.f0738c7b.svg";